import { Stack } from '@mui/material';
import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component, Fragment } from 'react';
import Section from '/@/components/section';
import Title from '/@/components/title';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import { buildOptions } from '/@/utils';
import Select from '/@/v3/components/forms/select';
import LinearRegressionChart from '../../charts/linear-regression-chart';
import styles from './styles.module.css';

@autobind
export default class LinearRegression extends Component {
    static propTypes = {
        crop: PropTypes.oneOf(['corn', 'soy']).isRequired,
        headToHead: PropTypes.shape({
            value: PropTypes.number.isRequired,
            head: PropTypes.shape({
                id: PropTypes.number.isRequired,
                name: PropTypes.string.isRequired,
            }).isRequired,
            other: PropTypes.shape({
                id: PropTypes.number.isRequired,
                name: PropTypes.string.isRequired,
            }).isRequired,
            trialCount: PropTypes.number.isRequired,
            winRate: PropTypes.number.isRequired,
            result: PropTypes.oneOf(['win', 'lose', 'tie']).isRequired,
            trialsByProduct: PropTypes.object.isRequired,
        }).isRequired,
        other: PropTypes.shape({
            id: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
        }).isRequired,
        otherOptions: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.number.isRequired,
                name: PropTypes.string.isRequired,
            })
        ).isRequired,
        setOther: PropTypes.func.isRequired,
        type: PropTypes.string,
        displayHeader: PropTypes.bool,
    };

    static defaultProps = {
        displayHeader: true,
    };

    static contextTypes = {
        units: PropTypes.object.isRequired,
    };

    renderFilters() {
        const { other, otherOptions, setOther, headToHead, displayHeader } = this.props;

        if (!other) return;

        return (
            <div className={styles.filters}>
                {setOther && (
                    <div className={styles.filter}>
                        <Title>{_('Producto a comparar')}</Title>
                        <Select
                            clearable={false}
                            value={other.id}
                            options={buildOptions(otherOptions)}
                            onChange={setOther}
                            color={settings.app.theme}
                        />
                    </div>
                )}
                <div className={styles.info}>
                    {this.props.type === 'trial' && (
                        <Fragment>
                            <div>
                                {_('Comparaciones')}: <span className={styles.value}>{headToHead.trialCount}</span>
                            </div>
                            <div>
                                {_('Win rate')}: <span className={styles.value}>{Math.round(headToHead.winRate)}%</span>
                            </div>
                        </Fragment>
                    )}
                    <div className={styles.references}>
                        <span>{_('Referencias')}:</span>
                        <div className={styles.product}>
                            <span className={classNames(styles.dot, styles.head)} /> {headToHead.head.name}
                        </div>
                        <div className={styles.product}>
                            <span className={classNames(styles.dot, styles.other)} /> {headToHead.other.name}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderChart() {
        const { headToHead, user, crop } = this.props;
        return (
            <LinearRegressionChart
                user={user}
                crop={crop}
                data={headToHead}
                renderValue={(value) => this.context.units.toYield(value, crop).toString()}
            />
        );
    }

    render() {
        if (!this.props.displayHeader)
            return (
                <Stack width={'100%'}>
                    {this.renderFilters()}
                    {this.renderChart()}
                </Stack>
            );

        return (
            <Section title={_('Regresión lineal')}>
                <div className={styles.root}>
                    {this.renderFilters()}
                    {this.renderChart()}
                </div>
            </Section>
        );
    }
}
